import React from 'react';
import { TextField, Card, CardTitle, CardText, CardActions, Button , DialogContainer, List, ListItem} from 'react-md';
import { Avatar, Chip, SVGIcon } from 'react-md';
import {
  DataTable,
  TableHeader,
  TableCardHeader,
  TableBody,
  TableRow,
  TableColumn,
} from 'react-md';

import AddProjectDialog from './AddProjectDialog';
import backend from './../App/backend';
import FlatOrIconButton from './../Shared/FlatOrIconButton';


class ProjectList extends React.Component {
    constructor(props) {
            super(props);
            this.state = {
              history: [{
                squares: Array(9).fill(),
              }],
              name: null,
              testRuns: null,
              projects: null,
              testPlan: null,
              testRun: null,
              error1: null,
              isLoaded: false,
              isRunning: false
            };

             this.handleRunClick = this.handleRunClick.bind(this);
             this.showTestRuns = this.showTestRuns.bind(this);
        }

         componentDidMount() {
                this.fetchProjects();
              }

               handleRunClick(project) {
                      this.fetchTestPlans(project);
                  }

           handleDeleteClick(selfLink) {
                var id = selfLink.split("/")[5];
                this.deleteProject(id);
            }

          showTestRuns(selfLink) {
                var projectId = selfLink.split("/")[5];
                const url = '#/testRuns/'+projectId;
                    window.open(url, '_self');
            }

         showProjectDetails(selfLink) {
            var projectId = selfLink.split("/")[5];
            const url = '#/projects/'+projectId;
            window.open(url, '_self');
         }

    runProject(project) {
        var id = project._links.self.href.split("/")[5];
        fetch(backend.url + '/projects/' + id + '/run')
          .then(res => res.json())
          .then(
            (result) => {
              this.setState({
                isLoaded: true,
                testPlan: result
              });
            },
            (error) => {
              this.setState({
                isLoaded: true,
                error1: error
              });
            }
          )
      }


      runTestPlan(testPlan) {
          fetch(backend.url + '/testPlans/' + testPlan.id + '/run')
            .then(res => res.json())
            .then(
              (result) => {
                this.setState({
                  isLoaded: true,
                  selectRunConfigurationDialogVisible: false,
                  testPlan: result
                });
              },
              (error) => {
                this.setState({
                  isLoaded: true,
                  error1: error
                });
              }
            )
        }

      deleteProject(id) {
          fetch(backend.url + '/projects/' + id + '/delete')
            .then(res => res.json())
            .then(
              (result) => {

                this.setState({
                  isLoaded: true
                });
                this.fetchProjects();

              },
              (error) => {
                this.setState({
                  isLoaded: true,
                  error1: error
                });
              }
            )
        }


 addProject1(opts) {
       fetch(backend.url + '/projects', {
            method: 'POST',
             headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                    },
            body: JSON.stringify(opts)
          })
          .then(res => res.json())
          .then(
            (result) => {
              this.fetchProjects();
              this.setState({
                isLoaded: true,
                 addRowDialogVisible: false,
                testRun: result
              });
            },
            (error) => {
              this.setState({
                isLoaded: true,
                error1: error
              });
            }
          )
      }

    fetchTestPlans(project) {
      fetch(project._links.testPlans.href)
        .then(res => res.json())
        .then(
          (result) => {

            this.setState({
              isLoaded: true,
              testPlans: result
            });

            if(this.state.testPlans.length > 1){
                this.setState({ selectRunConfigurationDialogVisible: true });
            }else{
                this.runProject(project);
            }

          },
          (error) => {
            this.setState({
              isLoaded: true,
              error1: error
            });
          }
        )
    }

      fetchProjects() {
        fetch(backend.url + '/projects/search/findByDeleted?deleted=false')
          .then(res => res.json())
          .then(
            (result) => {
              this.setState({
                isLoaded: true,
                projects: result._embedded.projects
              });
            },
            (error) => {
              this.setState({
                isLoaded: true,
                //error1: error
              });
            }
          )
      }

  showAddRowDialog = () => {

   this.setState({ addRowDialogVisible: true });

  };

  hideAddRowDialog = () => {
    this.setState({ addRowDialogVisible: false });
  };

    hideSelectRunConfigurationDialog = () => {
      this.setState({ selectRunConfigurationDialogVisible: false });
    };

        hideSelectRunConfigurationDialog1 = (e) => {

        alert("hideSelectRunConfigurationDialog1: "+ e);
       // alert("hideSelectRunConfigurationDialog1: "+ e.target.textContent);
          this.setState({ selectRunConfigurationDialogVisible: false });
        };



  addProject = (projectAttributes1) => {

    var projectAttributes = projectAttributes1[0];
    var project = {
    "name" : projectAttributes['name'],
      "testFramework" : projectAttributes['testFramework'],
      "repositoryUrl" : projectAttributes['repositoryUrl'],
      "clonePath" : projectAttributes['clonePath'],
      "testfileType" : projectAttributes['testfileType'],
      "testRunner" : projectAttributes['testRunner']
      };

    this.addProject1(project);
  };



    removeSelected = () => {
    };

     reset = () => {
      };


render() {
var projects = null;
var testPlans = null;
var error = null;

var divStyle ={
cursor:'pointer',
};

    if(this.state.isLoaded){
        if(this.state.projects){
            projects = this.state.projects.map((item, i) => (
                               /* <TableRow key={i} >*/
                                <TableRow key={i} style={divStyle}>
                                    <TableColumn onClick={() => this.showProjectDetails(item._links.self.href)}>{ item.name }</TableColumn>
                                    <TableColumn onClick={() => this.showProjectDetails(item._links.self.href)}>{ item.testFramework }</TableColumn>
                                    <TableColumn onClick={() => this.showProjectDetails(item._links.self.href)}>{ item.testfileType }</TableColumn>
                                    <TableColumn onClick={() => this.showProjectDetails(item._links.self.href)}>{ item.testRunner }</TableColumn>
                                    <TableColumn onClick={() => this.showProjectDetails(item._links.self.href)}>{ item.repositoryUrl }</TableColumn>
                                    <TableColumn>
                                    <Button flat primary swapTheming onClick={() => this.handleRunClick(item)}>{this.state.isRunning ? 'Running' : 'Run'}</Button>
                                    <Button flat primary swapTheming onClick={() => this.handleDeleteClick(item._links.self.href)}>{'Delete'}</Button>
                                    </TableColumn>
                                  </TableRow>
                              ));
        }

        if(this.state.testPlans){
             testPlans = this.state.testPlans.map((item, i) => (
                                 /* <TableRow key={i} >*/
                                  <TableRow key={i} style={divStyle} onClick={() => this.runTestPlan(item)}>
                                      <TableColumn>{ item.name }</TableColumn>
                                      <TableColumn>{ item.operatingSystem }</TableColumn>
                                      <TableColumn>{ item.browser }</TableColumn>
                                    </TableRow>
                                ));
        }

        if(this.state.error1){
            error = this.state.error1.stack;
        }
    }


    return (
 <Card tableCard>

     <TableCardHeader
            title="Projects"
          >
          <FlatOrIconButton onClick={this.showAddRowDialog} iconChildren="add">Add</FlatOrIconButton>

      </TableCardHeader>





<AddProjectDialog
    visible={this.state.addRowDialogVisible}
    hideAddRowDialog={this.hideAddRowDialog}
    addProject={this.addProject}
/>

<DialogContainer
          id="simple-list-dialog"
          visible={this.state.selectRunConfigurationDialogVisible}
          title="Select a run configuration"
          onHide={this.hideSelectRunConfigurationDialog}
          focusOnMount={false}
          width={400}
        >
        <Card tableCard>
       <DataTable plain>
           <TableHeader>
             <TableRow>
               <TableColumn>Name</TableColumn>
               <TableColumn>operatingSystem</TableColumn>
               <TableColumn>browser</TableColumn>
             </TableRow>
           </TableHeader>
           <TableBody>
               { testPlans }
           </TableBody>
         </DataTable>
         </Card>
</DialogContainer>

<DataTable plain>
    <TableHeader>
      <TableRow>
        <TableColumn>Name</TableColumn>
        <TableColumn>testFramework</TableColumn>
        <TableColumn>testfileType</TableColumn>
        <TableColumn>testRunner</TableColumn>
        <TableColumn>repositoryUrl</TableColumn>
        <TableColumn>Action</TableColumn>
      </TableRow>
    </TableHeader>
    <TableBody>
        { projects }
      { error }
    </TableBody>
  </DataTable>
</Card>
);
}

}

export default ProjectList;



// WEBPACK FOOTER //
// ./src/containers/Project/List.js